import { Component, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { JsonHelper } from "./jsonHelper";
import { NewOption } from "../common/static-data-common";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class Validator {
  private requiredArr: Array<any>;
  private jsonObject: any;
  private jsonPath: string;
  private model: any;
  private getModelFunc: any;
  public isSubmitted = false;
  private Newoption = NewOption;
  private isSetModelAsync = false;
  public isDebug = false;
  private static firstToaster: any = "";

  constructor(
    public jsonHelper: JsonHelper,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.requiredArr = [];
  }

  public static getValidator(
    model: any,
    jsonpath: string,
    jsonHelper: JsonHelper,
    isSubmitted,
    toastr: ToastrService,
    translate: TranslateService
  ): Validator {
    let newValidator = new Validator(jsonHelper, toastr, translate);
    newValidator.setJSON(jsonpath);
    newValidator.setModel(model);
    newValidator.isSubmitted = isSubmitted;

    return newValidator;
  }

  public setJSON(jsonpath: string) {
    this.jsonPath = "validator/" + jsonpath;

    this.jsonHelper.getJSON(this.jsonPath).subscribe((data) => {
      this.jsonObject = data;
    });
  }

  public setJSONObject(object: any) {
    this.jsonPath = "";
    this.jsonObject = object;
  }

  private setValidElement(fieldname, isValidFunc) {
    var data = this.requiredArr.filter((x) => x.name == fieldname);

    if (data.length == 0)
      this.requiredArr.push({ name: fieldname, isValid: isValidFunc });
    else data[0].isValid = isValidFunc;
  }

  public setModel(model: any) {
    this.model = model;
  }

  public setModelAsync(func: any) {
    this.isSetModelAsync = true;
    this.getModelFunc = func;
  }

  private initModel() {
    if (this.isSetModelAsync) {
      this.model = this.getModelFunc();
    }
  }

  private getField(fieldName) {
    if (this.jsonObject == null) {
      return null;
    }
    return this.jsonObject.fields[fieldName];
  }

  private getModelField(fieldName) {
    this.initModel();

    if (this.model == null) {
      return null;
    }

    this.debug(fieldName);
    return this.model[fieldName];
  }

  public initTost() {
    Validator.firstToaster = "";
  }

  public isValid(fieldName, isNoToaster?: boolean): boolean {
    this.debug(fieldName);
    this.setValidElement(fieldName, (filename) => this.isValid(filename));

    if (!this.isSubmitted) return true;

    var errors = this.getErrors(fieldName);
    // console.log("firstToaster:" + Validator.firstToaster);
    if (Validator.firstToaster == "") {
      if (errors.length > 0) {
        Validator.firstToaster = fieldName;
        for (let error of errors) {
          let tradMessage: string = "";
          if (!isNoToaster) {
            this.translate.get(error).subscribe((text: string) => {
              tradMessage = text;
            });
            this.toastr.warning(tradMessage, "Validation error");
          }
        }
      }
    }

    return errors.length == 0;
  }

  public isValidNoToaster(fieldName): boolean {
    this.debug(fieldName);
    this.setValidElement(fieldName, (filename) => this.isValid(filename));

    if (!this.isSubmitted) return true;

    var errors = this.getErrors(fieldName);
    // console.log("firstToaster:" + Validator.firstToaster);
    if (Validator.firstToaster == "") {
      if (errors.length > 0) {
        Validator.firstToaster = fieldName;
        for (let error of errors) {
          let tradMessage: string = "";
          this.translate.get(error).subscribe((text: string) => {
            tradMessage = text;
          });
          // this.toastr.warning(tradMessage, "Validation error");
        }
      }
    }

    return errors.length == 0;
  }

  public isValidIf(fieldName, flag): boolean {
    this.initModel();
    this.setValidElement(fieldName, (filename) =>
      this.isValidIf(filename, flag)
    );

    if (!this.isSubmitted) return true;

    var errors = this.getErrorsIf(fieldName, flag);

    return errors.length == 0;
  }

  public isValidIfAsync(fieldName, flagfunc, arg: any = null): boolean {
    this.initModel();
    this.setValidElement(fieldName, (filename) =>
      this.isValidIfAsync(filename, flagfunc, arg)
    );

    if (!this.isSubmitted) return true;

    var errors = this.getErrorsIf(fieldName, flagfunc(this.model, arg));

    return errors.length == 0;
  }

  //public isValidCompare(fieldName, fieldValue): boolean {

  //  this.setValidElement(fieldName, (filename) => this.isValidCompare(filename, fieldValue));

  //  if (!this.isSubmitted)
  //    return true;

  //  console.log("is valid compare");
  //  console.log("fieldValue:" + fieldValue);
  //  var errors = this.getErrorsCompare(fieldName, fieldValue);
  //  console.log("errors:" + errors.length);

  //  return errors.length == 0;
  //}

  //public getErrorsCompare(fieldName, fieldValue) {

  //  let field = this.getField(fieldName);

  //  let errors = [];

  //  if (field == null)
  //    return errors;

  //  for (let rule of field) {
  //    var error = this.getRuleError(fieldName, rule, fieldValue);

  //    if (error != null)
  //      errors.push(error);
  //  }

  //  return errors;
  //}

  private getRuleError(fieldName, rule: any): string {
    let fieldModel = this.getModelField(fieldName);

    this.debug("fieldName:" + fieldName);
    this.debug("fieldModel:" + fieldModel);

    if (rule.type == "required") {
      let fieldType = rule.fieldType;

      if (fieldType == null) fieldType = "T";

      if (this.required(fieldModel, fieldType, rule)) {
        return rule.ressource;
      }
    } else if (rule.type == "email") {
      if (this.email(fieldModel)) return rule.ressource;
    } else if (rule.type == "emails") {
      var emailList =
        fieldModel !== ""
          ? fieldModel
            .trim()
            .split(";")
            .filter((x) => x.trim())
          : null;
      if (emailList == null || emailList == "") return null;
      var item =
        emailList !== null ? emailList.filter((x) => this.email(x)) : null;
      if (item?.length > 0) return rule.ressource;
    } else if (rule.type == "whitespace") {
      if (this.whiteSpace(fieldModel)) return rule.ressource;
    } else if (rule.type == "date") {
      if (this.isDate(fieldModel)) {
        return rule.ressource;
      }
    } else if (rule.type == "number") {
      if (this.number(fieldModel)) {
        return rule.ressource;
      }
    } else if (rule.type == "isLessOrEqual") {
      let fieldType = rule.fieldType;
      let fieldCible = rule.fieldCible;
      if (fieldCible == null) return null;

      let fieldValue = this.getModelField(fieldCible);
      if (
        fieldValue != null &&
        fieldModel != null &&
        fieldType != null &&
        this.isLessOrEqual(fieldModel, fieldValue, fieldType)
      )
        return rule.ressource;
    } else if (rule.type == "isGreatOrEqual") {
      let fieldType = rule.fieldType;
      let fieldCible = rule.fieldCible;

      if (fieldCible == null) return null;

      let fieldValue = this.getModelField(fieldCible);

      if (
        fieldValue != null &&
        fieldModel != null &&
        fieldType != null &&
        this.isGreatOrEqual(fieldModel, fieldValue, fieldType)
      )
        return rule.ressource;
    } else if (rule.type == "productId") {
      if (this.productId(fieldModel)) return rule.ressource;
    }
    return null;
  }

  public getErrors(fieldName) {
    let field = this.getField(fieldName);

    let errors = [];

    if (field == null) return errors;

    for (let rule of field) {
      let error = this.getRuleError(fieldName, rule);
      if (error != null) errors.push(error);
    }
    return errors;
  }

  public getErrorsIf(fieldName, flag) {
    let field = this.getField(fieldName);
    let fieldModel = this.getModelField(fieldName);

    let errors = [];

    if (field == null) return errors;

    for (let rule of field) {
      if (rule.type == "required") {
        let fieldType = rule.fieldType;

        if (
          flag != null &&
          fieldType != null &&
          this.requiredIf(fieldModel, fieldType, flag)
        )
          errors.push(rule.ressource);
      } else if (rule.type == "email") {
        if (flag != null && this.emailIf(fieldModel, flag))
          errors.push(rule.ressource);
      } else if (rule.type == "number") {
        if (flag != null && this.numberIf(fieldModel, flag))
          errors.push(rule.ressource);
      } else if (rule.type == "isLessOrEqual") {
        let fieldType = rule.fieldType;
        let fieldCible = rule.fieldCible;
        if (fieldCible == null) return null;

        let fieldValue = this.getModelField(fieldCible);
        if (
          flag != null &&
          fieldValue != null &&
          fieldModel != null &&
          fieldType != null &&
          this.isLessOrEqualIf(fieldModel, fieldValue, fieldType, flag)
        )
          errors.push(rule.ressource);
      } else if (rule.type == "isGreatOrEqual") {
        let fieldType = rule.fieldType;
        let fieldCible = rule.fieldCible;

        if (fieldCible == null) return null;

        let fieldValue = this.getModelField(fieldCible);

        if (
          flag != null &&
          fieldValue != null &&
          fieldModel != null &&
          fieldType != null &&
          this.isGreatOrEqualIf(fieldModel, fieldValue, fieldType, flag)
        )
          errors.push(rule.ressource);
      }
    }

    return errors;
  }

  public required(value, type, rule: any) {
    if (type == "NP") return value == null || value <= 0;
    if (type == "N")
      return value == null || (value <= 0 && value != this.Newoption);
    if (type == "NU")
      //it will allow zero value
      return value == null;

    if (type == "T") return value == null || value.toString().trim() == "";

    if (type == "D") return value == null || value.toString().trim() == "";

    if (type == "A") return value == null || value.length <= 0;

    if (type == "AT") {
      if (value == null || value.length <= 0) return true;

      if (rule != null && rule.fields != null && rule.fields.length > 0) {
        for (let item of rule.fields) {
          for (let itemvalue of value) {
            let subitem = item.name;
            let subValue = itemvalue[subitem];
            let subFieldType = item.fieldType;

            let xx = this.required(subValue, subFieldType, null);

            if (!xx) return false;
          }
        }
        return true;
      }

      return false;
    }

    return true;
  }

  public requiredIf(value, type, flag) {
    if (flag) return this.required(value, type, null);

    return false;
  }
  public emailIf(value, flag) {
    if (flag) return this.email(value);

    return false;
  }
  // public email(value) {
  //   if (value == null || value == "") return false;

  //   //  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   var re = /^([a-z0-9._%+-]{2,})+@([a-z0-9.-])+\.([a-z]{2,4})$/;
  //   return !re.test(String(value).toLowerCase());
  // }

  public email(value) {
    if (value == null || value == "") return false;

    var re = /^[a-zA-Z0-9._%+&'/=?^`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
    return !re.test(String(value).trim());
  }

  public productId(value) {
    if (value == null || value == "") return false;

    var re = /^([a-zA-Z0-9._%+-])*$/;
    return !re.test(String(value));
  }
  public whiteSpace(value) {
    if (value == null || value == "") return false;

    //  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var re = /^[^\s]+(\s+[^\s]+)*$/;
    return !re.test(String(value).toLowerCase());
  }

  public numberIf(value: any, flag) {
    if (flag) return !isNaN(value);
  }

  public number(value: any) {
    return !isNaN(value);
  }

  public isDate(value) {
    if (value == null || value.toString() == "") return false;

    return value.year == null || value.month == null || value.day == null;
  }

  public isDecimal(value: any) {
    if (!this.number(value)) return true;
  }

  private isLessOrEqual(value1: any, value2: any, type) {
    if (type == "N") return value1 > value2;

    if (type == "TN") {
      let val1 = this.cleanNumber(value1);
      let val2 = this.cleanNumber(value2);
      return val1 > val2;
    }
    if (type == "D" && !this.isDate(value1) && !this.isDate(value2))
      return (
        value1.year > value2.year ||
        (value1.year == value2.year && value1.month > value2.month) ||
        (value1.year == value2.year &&
          value1.month == value2.month &&
          value1.day > value2.day)
      );
    else return false;
  }

  private isGreatOrEqual(value1: any, value2: any, type) {
    if (type == "N") return value1 < value2;

    if (type == "TN") {
      let val1 = this.cleanNumber(value1);
      let val2 = this.cleanNumber(value2);
      return val1 < val2;
    }

    if (type == "D" && !this.isDate(value1) && !this.isDate(value2))
      return (
        value1.year < value2.year ||
        (value1.year == value2.year && value1.month < value2.month) ||
        (value1.year == value2.year &&
          value1.month == value2.month &&
          value1.day < value2.day)
      );
    else return false;
  }
  private isLessOrEqualIf(value1: any, value2: any, type, flag) {
    if (flag) return this.isLessOrEqual(value1, value2, type);
  }

  private isGreatOrEqualIf(value1: any, value2: any, type, flag) {
    if (flag) return this.isGreatOrEqual(value1, value2, type);
  }

  public isFormValid() {
    let isValid: boolean = true;
    this.debug(this.requiredArr);
    for (let item of this.requiredArr) {
      if (!item.isValid(item.name)) {
        isValid = false;
        break;
      }
    }

    return isValid;
  }

  private debug(message) {
    if (this.isDebug) console.log(message);
  }
  public validate(fieldPath: string): boolean {
    if (this.isSetModelAsync) {
      this.model = this.getModelFunc();
    }
    const rules = this.jsonObject?.fields?.[this.normalizeArrayPath(fieldPath)];
    if (!rules) {
      console.warn(`No validation rules defined for "${fieldPath}".`);
      return true;
    }
    return this.validateFieldPath(this.model, fieldPath, rules);
  }

  private cleanNumber = (value) => {
    if (typeof value === "string") {
      // Remove commas, percentage symbol, and whitespace
      let cleanedValue = value.replace(/,/g, "").replace("%", "").trim();
      // Convert to number
      let number = parseFloat(cleanedValue);
      // If the original value had a percentage, divide by 100
      if (value.includes("%")) {
        number = number / 100;
      }
      return number;
    }
    // If already a number, return it as is
    return Number(value);
  };

  public validateFieldPath(fmodel: any, path: string, rules: any[]): boolean {

    if (!path.includes('[]')) {
      const value = this.resolveFieldValue(fmodel, path);
      return this.validateRules(fmodel, value, rules, path);
    }

    const parts = path.split(/\[\]/);
    const baseArrayPath = parts[0];
    const remainingPath = parts.slice(1).join('[]').replace(/^\./, ''); // strip leading dot

    const array = this.resolveFieldValue(fmodel, baseArrayPath);
    if (!Array.isArray(array)) return true;

    let isAllValid = true;

    array.forEach((item, index) => {
      const nestedPath = remainingPath ? `${baseArrayPath}[${index}].${remainingPath}` : `${baseArrayPath}[${index}]`;
      const nestedModel = this.resolveFieldValue(fmodel, `${baseArrayPath}.${index}`);
      isAllValid = this.validateFieldPath(nestedModel, nestedPath, rules) && isAllValid;
    });

    return isAllValid;
  }
  private validateRules(model: any, value: any, rules: any[], fieldPath: string): boolean {
    let isValid = true;
    if (!this.isSubmitted)
      return true;
    const errors: string[] = [];
    const fieldName = this.getFieldName(fieldPath);
    for (const rule of rules) {
      if (rule.type === 'required') {
        const isEmpty = value === null || value === undefined || value === '' ||
          (Array.isArray(value) && value.length === 0);
        if (isEmpty) {
          errors.push(rule.ressource || 'This field is required.');
          isValid = false;
          break;
        }
      }
    }

    this.setValidElement(fieldPath, isValid);
    if (Validator.firstToaster == "") {
      if (errors.length > 0) {
        Validator.firstToaster = fieldName;
        for (let error of errors) {
          let tradMessage: string = "";
          this.translate.get(error).subscribe((text: string) => { tradMessage = text });
          this.toastr.warning(tradMessage, "Validation error");
        }
      }
    }
    //return errors.length == 0;
    return isValid;
  }
  private validatingFields = new Set<string>();
  public getNestedErrors(fieldPath: string): string[] {
    if (!this.isSubmitted)
      return;
    if (this.isSetModelAsync) {
      this.model = this.getModelFunc();
    }
    var model = this.model;
    // Prevent recursive validation on the same path
    if (this.validatingFields.has(fieldPath)) {
      return [];
    }
    this.validatingFields.add(fieldPath);
    try {
      const rules = this.jsonObject?.fields?.[this.normalizeArrayPath(fieldPath)];
      if (!rules) return [];

      const value = this.resolveFieldValue(model, fieldPath);
      const errors: string[] = [];

      for (const rule of rules) {
        if (rule.type === 'required') {
          const isEmpty = value === null || value === undefined || value === '' ||
            (Array.isArray(value) && value.length === 0);
          if (isEmpty) {
            errors.push(rule.ressource || 'This field is required.');
          }
        }
      }
      return errors;
    } finally {
      this.validatingFields.delete(fieldPath);
    }
  }
  private normalizeArrayPath(path: string): string {
    return path.replace(/\[\d+\]/g, '[]');
  }
  private resolveFieldValue(model: any, path: string): any {
    const pathParts = path.replace(/\[(\d+)\]/g, '.$1').split('.');
    return pathParts.reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : null, model);
  }
  private getFieldName(path: string): string {
    return path.split('.').pop()!;
  }
}

